const API_ROOT = `${process.env.REACT_APP_API_URL}/api/v1/`;

const request = (method, endpoint, body, imageFlag) => {
  let serializedBody;
  if (imageFlag) {
    serializedBody = method !== 'GET' ? { body } : null;
  } else {
    serializedBody = method !== 'GET' ? { body: JSON.stringify(body) } : null;
  }

  let creds = null;

  if (localStorage.state) {
    const localState = JSON.parse(localStorage.state);
    creds = {
      'X-User-Email': localState.auth.email,
      'X-User-Token': localState.auth.token,
    };
  }

  const config = {
    method,
    headers: {
      ...creds,
    },
    ...serializedBody,
  };

  if (!imageFlag) {
    config.headers['Content-Type'] = 'application/json';
  }

  return fetch(`${API_ROOT}${endpoint}`, config)
    .then(response => handleErrors(response))
    .catch(err => {
      throw err;
    });
};

const handleErrors = response =>
  response.json().then(responseData => {
    // If response has a status outside 200-299 then it will be caught here
    if (!response.ok) {
      console.log('Request error');
      throw responseData;
    }
    return responseData;
  });

// export const uberLogin = () => {
//   return fetch(`${process.env.REACT_APP_API_URL}/users/auth/uber`, {
//     // return fetch(
//     //   `https://login.uber.com/oauth/v2/authorize?response_type=code&client_id=pem6v1nd9XaPZ-AKbDnhgI8Z06I7iqJA&scope=partner.admin_accounts+partner.admin_trips+partner.payments+partner.vehicles+profile&redirect_uri=http://localhost:3001/users/auth/uber/callback`,
//     //   {
//     method: "GET",
//     headers: {
//       ...creds
//     }
//   })
//     .then(response => handleErrors(response))
//     .catch(err => console.log(err));
// };

// Pass in auth token once implemented
export const getData = endpoint => request('GET', endpoint);
export const deleteData = endpoint => request('DELETE', endpoint);
export const postData = (endpoint, body, imageFlag) => request('POST', endpoint, body, imageFlag);
export const putData = (endpoint, body, imageFlag) => request('PUT', endpoint, body, imageFlag);



// WEBPACK FOOTER //
// ./src/utils/request.js